<template>
  <div>
    <div class="sunflowerCalendarToolbar">
      <div class="left">
        <ButtonGroup>
          <Button :type="currentModel == 'month'?'primary':'default'" @click="changeView('month')">月</Button>
          <Button :type="currentModel == 'week'?'primary':'default' " @click="changeView('week')">周</Button>
          <Button :type="currentModel == 'day'?'primary':'default' " @click="changeView('day')">日</Button>
        </ButtonGroup>
      </div>
      <div class="center">
        <Icon @click="prev" class="pointer" type="ios-arrow-back" />
        <div class="title">
          <template v-if="currentModel == 'month'">
            <DatePicker
              @on-change="(date, type) => changeView(this.currentModel, date)"
              class="simpleDp"
              format="yyyy-MM"
              type="month"
              v-model="title"
            ></DatePicker>
          </template>
          <template v-else>
            <DatePicker
              @on-change="(date, type) => changeView(this.currentModel, date)"
              class="simpleDp"
              format="yyyy-MM-dd"
              type="date"
              v-model="title"
            ></DatePicker>
          </template>
          <!-- <template v-else>{{title}}</template> -->
        </div>
        <Icon @click="next" class="pointer" type="ios-arrow-forward" />
      </div>
      <div class="right">
        <Select @on-change="handleType" style="margin-right: 20px" v-model="type">
          <Option value="dategrid">日程表</Option>
          <Option v-if="currentModel != 'day'" value="timeline">时间轴</Option>
        </Select>
      </div>
    </div>
    <Spin fix v-if="loading">
      <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
      <div>{{calendarOptions.tips}}</div>
    </Spin>
    <FullCalendar :options="calendarOptions" id="calendar" ref="fullCalendar">
      <template v-slot:eventContent="arg">
        <slot :arg="arg" name="eventDetail">
          <h3 class="eventTitle">{{arg.event.title}}</h3>
          <div
            class="eventRange"
          >{{$moment(arg.event.start).format('YYYY-MM-DD HH:mm:ss')}} / {{$moment(arg.event.end).format('YYYY-MM-DD HH:mm:ss')}}</div>
        </slot>
      </template>
      <!-- <template v-slot:dayCellContent="arg">{{ arg.dayNumberText }}</template> -->
      <template v-slot:resourceLabelContent="arg">
        <slot :arg="arg" name="sourceDetail">
          <h3 class="eventTitle">{{arg.resource.title}}</h3>
          <div
            class="eventRange"
          >{{$moment(arg.resource.start).format('YYYY-MM-DD HH:mm:ss')}} / {{$moment(arg.resource.end).format('YYYY-MM-DD HH:mm:ss')}}</div>
        </slot>
      </template>
    </FullCalendar>
  </div>
</template>
<script>
// https://fullcalendar.io/docs/vue
import FullCalendar from "@fullcalendar/vue"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import listPlugin from "@fullcalendar/list"
import interactionPlugin from "@fullcalendar/interaction"
import resourceTimelinePlugin from "@fullcalendar/resource-timeline"
import momentPlugin from "@fullcalendar/moment"

let clickCount = 0
let prev = "" // 上一次点击的dom节点
export default {
  name: 'sunflowerCalendar',
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  props: {
    eventsMap: {
      required: false,
      default: function () {
        return {}
      }
    },
    options: {
      required: false,
      default: function () {
        return {}
      }
    },
    loading: false

  },
  data () {
    return {
      title: "",
      currentModel: '',
      currentView: '',
      type: "dategrid",
      defaultOptions: {
        tips: '加载中，请稍候...',
        locale: "zh",
        timeZone: "local",
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          listPlugin,
          resourceTimelinePlugin,
          interactionPlugin,
          momentPlugin
        ],
        buttonText: {
          // 设置按钮
          today: "今天",
          month: "月",
          week: "周",
          dayGrid: "天",
        },
        // initialView: "dayGridMonth", // 设置默认显示月，可选周、日
        // resourceAreaWidth: 200,
        // contentHeight: 600,
        // slotMinWidth: 70,
        editable: false,
        dayMaxEvents: false, // allow "more" link when too many events
        allDaySlot: false, //不显示all-day（全天）
        firstDay: 0, //设置一周中显示的第一天是哪天，周日是o，周一是1，类推
        dayMaxEventRows: 5, //单元格最多显示日程数
        fixedWeekCount: true, //月视图显示周数,关闭显示正确周数
        eventDurationEditable: false, // 可以调整事件的时间
        selectable: false, // 日历格子可选择
        nowIndicator: true, // 现在的时间线显示
        eventDisplay: "block", // 争对全天的情况下，以块状显示
        headerToolbar: false, // 隐藏头部的导航栏
        selectMirror: false,
        displayEventEnd: true, // like 08:00 - 13:00
        expandRows: true,
        eventTimeFormat: {
          // like '14:30:00'
          hour: "2-digit",
          minute: "2-digit",
          meridiem: false,
          hour12: false, // 设置时间为24小时
        },
        forceEventDuration: true,
        events: [],
        eventColor: "#378006",
        // allDayText: "全天",
        dateClick: this.handleDateClick, //点击日程事件
        eventClick: this.handleEventClick,  //点击日历中的某一日程
        eventMouseEnter: this.handleEventEnter,// 事件鼠标进入
        eventMouseLeave: this.handleEventLeave,// 事件鼠标移出
        select: this.handleDateSelect, // 监听用户选择的时间段，
        eventDrop: this.handleEventDrop,  //监听事件被拖动的操作
        eventResize: this.handleEventResize, //监听事件调整大小的操作
        resourceAreaHeaderContent: "Schedules",
        resourceOrder: "id",
        resources: [],
        schedulerLicenseKey: "GPL-My-Project-Is-Open-Source",
        // resourceLabelContent (arg) {
        //   return {
        //     html: `<div>id: ${arg.resource.id}</div><div>title: ${arg.resource.title}</div>`,
        //   }
        // },
        // 视图配置
        views: {
          customTimeLineMonth: {
            type: "resourceTimeline",
            duration: { month: 1 },
            slotLabelFormat: {
              month: 'numeric',
              weekday: "short",
              day: "numeric",
              omitZeroMinute: true,
            },
          },
          // 周时间轴视图
          customTimeLineWeek: {
            type: "resourceTimeline",
            duration: { weeks: 1 },
            slotDuration: { days: 1 },
            // buttonText: "Custom Week",
            slotLabelFormat: {
              weekday: "short",
              month: 'numeric',
              day: 'numeric',
              omitZeroMinute: true,
            },
          },

          customGridWeek: {
            type: "timeGridWeek",
            dayHeaderFormat: {
              weekday: "short",
              month: 'numeric',
              day: 'numeric',
            },
            slotLabelFormat: {
              // 左侧时间格式
              hour: "2-digit",
              minute: "2-digit",
              meridiem: "lowercase",
              hour12: false, // false设置时间为24小时
            },
          },
          timeGridDay: {
            type: "timeGridDay",
            dayHeaderFormat: {
              weekday: "short"
            },
            slotLabelFormat: {
              // 左侧时间格式
              hour: "2-digit",
              minute: "2-digit",
              meridiem: "lowercase",
              hour12: false, // false设置时间为24小时
            },
          },
          resourceTimeline: {
            type: "resourceTimeline",
            slotLabelFormat: {
              // 顶时间格式
              hour: "2-digit",
              minute: "2-digit",
              // second: "2-digit",
              meridiem: "lowercase",
              hour12: false, // false设置时间为24小时
            },
          },
        },
        // 切换视图调用的方法
        datesSet () { },
      },
      calendarApi: null,
      dayDate: '',
      selectInfo: {},
    }
  },
  computed: {
    calendarOptions: function () {
      let de = { ...this.defaultOptions, ...this.options }
      console.log('calendarOptions', de)
      return de
    }
  },
  watch: {
    eventsMap: {
      immediate: true,
      handler: function (newVal) {
        console.log('events change', newVal)
        this.renderEvent()
      }
    },
  },
  methods: {
    // 监听用户选择的时间段，当用户选择了一段时间后会触发该回调，可以在这里处理创建新的日程。
    handleDateSelect (selectInfo) {
      console.log('selectInfo: ', selectInfo)
      this.selectInfo = selectInfo

    },
    // 用户拖动移动事件时触发
    handleEventDrop (dropInfo) {
      console.log('dropInfo: ', dropInfo)
      // const updatedEvent = { ...dropInfo.event }
      // updatedEvent.start = dropInfo.revertDuration ? dropInfo.oldEvent.start : dropInfo.event.start
      // updatedEvent.end = dropInfo.event.end

      // // 更新服务器上的事件或者重新排序你的事件数组
      // // 示例：this.updateEventOnServer(updatedEvent);

      // // 如果是在内存中维护事件，则更新本地数据
      // const index = this.events.findIndex(e => e.id === updatedEvent.id)
      // if (index !== -1) {
      //   this.events.splice(index, 1, updatedEvent)
      // }
      this.$emit('eventDrop', dropInfo)
    },
    // 用户调整事件长度时触发
    handleEventResize (resizeInfo) {
      console.log('resizeInfo: ', resizeInfo)
      // const updatedEvent = { ...resizeInfo.event }
      // updatedEvent.end = resizeInfo.event.end

      // // 同样更新服务器或本地数据
      // // 示例：this.updateEventOnServer(updatedEvent);

      // const index = this.events.findIndex(e => e.id === updatedEvent.id)
      // if (index !== -1) {
      //   this.events.splice(index, 1, updatedEvent)
      // }
      this.$emit('eventResize', resizeInfo)
    },
    renderEvent () {
      console.log('renderEvent', this.eventsMap)
      switch (this.currentView) {
        case 'timeGridDay':
        case 'resourceTimeline':
        case 'customGridWeek':
          this.defaultOptions.events = this.eventsMap.dayEvent || []
          this.defaultOptions.resources = this.eventsMap.dayEvent || []
          break
        default:
          // this.defaultOptions.events = this.eventsMap.dayEvent || []
          // this.defaultOptions.resources = this.eventsMap.dayEvent || []
          this.defaultOptions.events = this.eventsMap.default || []
          this.defaultOptions.resources = this.eventsMap.default || []
          break
      }
      // this.$nextTick(() => {
      //   if (this.calendarApi) this.calendarApi.render()
      // })
    },
    // 点击更多
    more (e) {
      console.log('more ', e)
    },
    //点击日历中的某一日程
    handleEventClick (clickInfo) {
      console.log('clickInfo:', clickInfo)
      // 用户点击事件时触发，用于编辑或删除事件
      const event = clickInfo.event
      // 这里可以弹出模态框进行编辑或调用删除函数等操作
      this.$emit('eventClick', event)
    },
    handleEventEnter (mouseEnterInfo) {
      mouseEnterInfo.el.style.opacity = 0.8
      // 用户点击事件时触发，用于编辑或删除事件
      this.$emit('eventEnter', mouseEnterInfo.event)
    },
    handleEventLeave (mouseEnterInfo) {
      // 用户点击事件时触发，用于编辑或删除事件
      mouseEnterInfo.el.style.opacity = 1
      // 这里可以弹出模态框进行编辑或调用删除函数等操作
      this.$emit('eventLeave', mouseEnterInfo.event)
    },
    // 单击事件(日历中的某一天)
    handleDateClick (e) {
      this.dayDate = e.dateStr
      if (e.dateStr !== prev) {
        clickCount = 0
      }
      clickCount += 1
      prev = e.dateStr
      setTimeout(() => {
        if (clickCount === 2) {
          console.log("dbClick", e.dateStr)

        } else if (clickCount === 1) {
          console.log("singleClick", e.dateStr)
          switch (this.currentView) {
            case 'timeGridDay':
            case 'resourceTimeline':
            case 'customGridWeek':
              // 24小时视图
              break
            default:
              this.changeView('day', e.dateStr)
              this.title = this.calendarApi.view.title
              break
          }
        }
        clickCount = 0
      }, 300)
    },
    // 切换
    prev () {
      this.calendarApi.prev()
      this.title = this.calendarApi.view.title
    },
    next () {
      this.calendarApi.next()
      this.title = this.calendarApi.view.title
    },
    changeView: function (viewType, date) {
      console.log(viewType, date)
      this.currentModel = viewType
      switch (viewType) {
        case 'day':
          // if (this.type === "timeline") {
          //   this.currentView = 'resourceTimeline'
          // } else {
          this.type = 'dategrid'
          this.currentView = 'timeGridDay'
          // }
          break
        case 'week':
          if (this.type === "timeline") {
            this.currentView = 'customTimeLineWeek'
          } else {
            this.currentView = 'customGridWeek'
          }
          break
        default:
          if (this.type === "timeline") {
            this.currentView = 'customTimeLineMonth'
          } else {
            this.currentView = 'dayGridMonth'
          }
          break
      }
      if (date) {
        this.calendarApi.changeView(this.currentView, date)
      } else {
        this.calendarApi.changeView(this.currentView)
        this.calendarApi.today()
      }
      this.title = this.calendarApi.view.title
      this.renderEvent()
    },
    // 选择时间线、日程
    handleType () {
      this.changeView(this.currentModel)
      // if (this.type === "timeline") {
      //   this.calendarApi.changeView("customTimeLineMonth")
      //   // this.defaultOptions.slotLabelFormat = null
      // } else {
      //   this.calendarApi.changeView("dayGridMonth")
      // }
    },
  },
  beforeMount () {
    this.$nextTick(() => {
      this.calendarApi = this.$refs.fullCalendar.getApi()
      this.changeView('month')
    })
  },
  beforeDestroy () {
    console.log('beforeDestroy calendarApi...')
    if (this.calendarApi) this.calendarApi.destroy()
  },
};
</script>
<style lang="less" scoped>
.sunflowerCalendarToolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;

  .center {
    width: max-content;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .title {
      padding: 4px;
      font-size: 1rem;
    }
  }
}
</style>

<style lang="less">
.eventTitle {
  font-weight: 600;
  padding: 2px;
  border-bottom: 1px dashed #fff;
  // word-break: break-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.eventRange {
  padding: 2px;
  display: flex;
  justify-content: flex-start;
}

.eventLabel {
  font-size: 0.8rem;
  margin-right: 0.6rem;
}

.fc-col-header,
.fc-timeline-header-row {
  a {
    cursor: default !important;
  }
}

.fc-daygrid-body,
.fc-timeline-body {
  .fc-day:not(.fc-col-header-cell) {
    cursor: pointer;
    position: relative;
  }

  .fc-day:not(.fc-col-header-cell):hover {
    background: #fafafa;
  }
}

// .fc-day:not(.fc-col-header-cell):hover {
//   &::after {
//     content: '双击进入天视图';
//     position: absolute;
//     font-size: 12px;
//     background: #eee;
//     padding: 2px;
//     border-radius: 2px;
//     left: 0;
//     right: 0;
//     margin: auto;
//     max-width: max-content;
//     top: 0;
//     bottom: 0;
//     max-height: fit-content;
//   }
// }
.simpleDp {
  .ivu-input {
    border: none;
    text-align: center;
    font-size: 1rem;
  }

  .ivu-input-suffix {
    display: none;
  }

  .ivu-input-with-suffix {
    padding-right: 7px;
  }

  .ivu-date-picker-focused input {
    box-shadow: none !important;
  }
}
</style>

